module.exports = __webpack_public_path__ + "static/media/publicGroup.de4e9bca.svg";